import {getGlobal} from 'reactn'
import momentTz from "moment-timezone";


export default () => {
    const {user} = getGlobal()
    return user?.time_zone || momentTz.tz.guess()
}
